import React from "react";

import { Route, withRouter, Switch } from "react-router-dom";
import asyncComponent from "../../helpers/AsyncFunc";
import PermissionWrapper from "../../components/PermissionWrapper";
import { satisfyPermissionSets } from "../../hooks/permission";
import { usePermissions } from "../../query/api";

const routes = [
  {
    path: "",
    component: asyncComponent(() => import("../Member/index.js")),
    requiredPermissionSets: [[{ section: "MEMBER", function: "LIST" }]],
  },
  {
    path: "banner",
    component: asyncComponent(() => import("../Banner/index.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "LIST" }]],
  },
  {
    path: "banner/create",
    component: asyncComponent(() => import("../Banner/create.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "CREATE" }]],
  },
  {
    path: "banner/edit/:id",
    component: asyncComponent(() => import("../Banner/edit.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "EDIT" }]],
  },
  {
    path: "banner/view/:id",
    component: asyncComponent(() => import("../Banner/view.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "VIEW_DETAILS" }]],
  },
  {
    path: "dynamicBannerList",
    component: asyncComponent(() => import("../DynamicBannerList/index.js")),
    requiredPermissionSets: [[{ section: "BANNER_LIST", function: "LIST" }]],
  },
  {
    path: "dynamicBannerList/edit/:id",
    component: asyncComponent(() => import("../DynamicBannerList/edit.js")),
    requiredPermissionSets: [[{ section: "BANNER_LIST", function: "EDIT" }]],
  },
  {
    path: "dynamicBannerList/view/:id",
    component: asyncComponent(() => import("../DynamicBannerList/view.js")),
    requiredPermissionSets: [
      [{ section: "BANNER_LIST", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "dashboard",
    component: asyncComponent(() => import("../Member/index.js")),
    requiredPermissionSets: [[{ section: "MEMBER", function: "LIST" }]],
  },
  {
    path: "contactlessParking",
    component: asyncComponent(() => import("../ContactlessParking/index.js")),
    requiredPermissionSets: [
      [{ section: "CONTACTLESS_PARKING", function: "LIST" }],
    ],
  },
  {
    path: "parkingRecord",
    component: asyncComponent(() => import("../ParkingRecord/index.js")),
    requiredPermissionSets: [
      [{ section: "PARKING_RECORDS", function: "LIST" }],
    ],
  },
  {
    path: "parkingRecord/create",
    component: asyncComponent(() => import("../ParkingRecord/create.js")),
    requiredPermissionSets: [
      [{ section: "PARKING_RECORDS", function: "CREATE" }],
    ],
  },
  {
    path: "contactlessParking/edit/:id",
    component: asyncComponent(() => import("../ContactlessParking/edit.js")),
    requiredPermissionSets: [
      [{ section: "CONTACTLESS_PARKING", function: "EDIT" }],
    ],
  },
  {
    path: "member",
    component: asyncComponent(() => import("../Member/index.js")),
    requiredPermissionSets: [[{ section: "MEMBER", function: "LIST" }]],
  },
  {
    path: "member/view/:userId",
    component: asyncComponent(() => import("../Member/view.js")),
    requiredPermissionSets: [[{ section: "MEMBER", function: "VIEW_DETAILS" }]],
  },
  {
    path: "member/edit/:userId",
    component: asyncComponent(() => import("../Member/edit.js")),
    requiredPermissionSets: [[{ section: "MEMBER", function: "EDIT" }]],
  },
  {
    path: "member/create",
    component: asyncComponent(() => import("../Member/create.js")),
    requiredPermissionSets: [[{ section: "MEMBER", function: "CREATE" }]],
  },
  {
    path: "spendingTransaction",
    component: asyncComponent(() => import("../SpendingTransaction/index.js")),
    requiredPermissionSets: [
      [{ section: "SPENDING_TRANSACTION", function: "LIST" }],
    ],
  },
  {
    path: "gift",
    component: asyncComponent(() => import("../Gift/index.js")),
    requiredPermissionSets: [[{ section: "GIFT", function: "LIST" }]],
  },
  {
    path: "gift/create",
    component: asyncComponent(() => import("../Gift/create.js")),
    requiredPermissionSets: [[{ section: "GIFT", function: "CREATE" }]],
  },
  {
    path: "gift/edit/:id",
    component: asyncComponent(() => import("../Gift/edit.js")),
    requiredPermissionSets: [[{ section: "GIFT", function: "EDIT" }]],
  },
  {
    path: "gift/view/:id",
    component: asyncComponent(() => import("../Gift/edit.js")),
    requiredPermissionSets: [[{ section: "GIFT", function: "VIEW_DETAILS" }]],
  },
  {
    path: "receiptScanning",
    component: asyncComponent(() => import("../ReceiptScanning/index.js")),
    requiredPermissionSets: [],
  },
  {
    path: "onlineEnquiry",
    component: asyncComponent(() => import("../OnlineEnquiry/index.js")),
    requiredPermissionSets: [],
  },
  {
    path: "onlineEnquiry/edit/:id",
    component: asyncComponent(() => import("../OnlineEnquiry/edit.js")),
    requiredPermissionSets: [],
  },
  {
    path: "sdollar",
    component: asyncComponent(() => import("../SDollar/index.js")),
    requiredPermissionSets: [
      [{ section: "S_COUPON_AND_S_DOLLAR_SHOPS", function: "LIST" }],
    ],
  },
  {
    path: "sdollar/view/:id",
    component: asyncComponent(() => import("../SDollar/view.js")),
    requiredPermissionSets: [
      [{ section: "S_COUPON_AND_S_DOLLAR_SHOPS", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "mall",
    component: asyncComponent(() => import("../Mall/index.js")),
    requiredPermissionSets: [[{ section: "SHOP", function: "LIST" }]],
  },
  {
    path: "mall/edit/:id",
    component: asyncComponent(() => import("../Mall/edit.js")),
    requiredPermissionSets: [[{ section: "SHOP", function: "EDIT" }]],
  },
  {
    path: "shop",
    component: asyncComponent(() => import("../Shop/index.js")),
    requiredPermissionSets: [[{ section: "SHOP", function: "LIST" }]],
  },
  {
    path: "shop/create",
    component: asyncComponent(() => import("../Shop/create.js")),
    requiredPermissionSets: [
      [{ section: "SHOP", function: "UPLOAD_MERCHANT_LIST" }],
    ],
  },
  {
    path: "shop/view/:id",
    component: asyncComponent(() => import("../Shop/view.js")),
    requiredPermissionSets: [[{ section: "SHOP", function: "VIEW_DETAILS" }]],
  },
  {
    path: "crazyAd",
    component: asyncComponent(() => import("../CrazyAd/index.js")),
    requiredPermissionSets: [[{ section: "CRAZY_AD", function: "LIST" }]],
  },
  {
    path: "crazyAd/create",
    component: asyncComponent(() => import("../CrazyAd/create.js")),
    requiredPermissionSets: [[{ section: "CRAZY_AD", function: "CREATE" }]],
  },
  {
    path: "crazyAd/edit/:id",
    component: asyncComponent(() => import("../CrazyAd/edit.js")),
    requiredPermissionSets: [[{ section: "CRAZY_AD", function: "EDIT" }]],
  },
  {
    path: "crazyAd/view/:id",
    component: asyncComponent(() => import("../CrazyAd/edit.js")),
    requiredPermissionSets: [
      [{ section: "CRAZY_AD", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "mission",
    component: asyncComponent(() => import("../Activity/Mission/index.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "LIST" }]],
  },
  {
    path: "mission/create",
    component: asyncComponent(() => import("../Activity/Mission/create.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "CREATE" }]],
  },
  {
    path: "mission/edit/:id",
    component: asyncComponent(() => import("../Activity/Mission/edit.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "EDIT" }]],
  },
  {
    path: "mission/view/:id",
    component: asyncComponent(() => import("../Activity/Mission/view.js")),
    requiredPermissionSets: [
      [{ section: "ACTIVITY", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "mission/edit/:missionId/memberSegment/create",
    component: asyncComponent(
      () => import("../Activity/MemberSegment/MissionSegment/create.js"),
    ),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "CREATE" }]],
  },
  {
    path: "mission/edit/:missionId/memberSegment/edit/:id",
    component: asyncComponent(
      () => import("../Activity/MemberSegment/MissionSegment/edit.js"),
    ),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "EDIT" }]],
  },
  {
    path: "mission/view/:missionId/memberSegment/view/:id",
    component: asyncComponent(
      () => import("../Activity/MemberSegment/MissionSegment/view.js"),
    ),
    requiredPermissionSets: [
      [{ section: "ACTIVITY", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "stamp",
    component: asyncComponent(() => import("../Activity/Stamp/index.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "LIST" }]],
  },
  {
    path: "stamp/create",
    component: asyncComponent(() => import("../Activity/Stamp/create.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "CREATE" }]],
  },
  {
    path: "stamp/edit/:id",
    component: asyncComponent(() => import("../Activity/Stamp/edit.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "EDIT" }]],
  },
  {
    path: "stamp/view/:id",
    component: asyncComponent(() => import("../Activity/Stamp/view.js")),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "VIEW_DETAILS" }]],
  },
  {
    path: "stamp/edit/:stampId/memberSegment/create",
    component: asyncComponent(
      () => import("../Activity/MemberSegment/StampSegment/create.js"),
    ),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "CREATE" }]],
  },
  {
    path: "stamp/edit/:stampId/memberSegment/edit/:id",
    component: asyncComponent(
      () => import("../Activity/MemberSegment/StampSegment/edit.js"),
    ),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "EDIT" }]],
  },
  {
    path: "stamp/view/:stampId/memberSegment/view/:id",
    component: asyncComponent(
      () => import("../Activity/MemberSegment/StampSegment/view.js"),
    ),
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "VIEW_DETAILS" }]],
  },
  // deprecated, backwards compatibility
  {
    path: "campaign",
    component: asyncComponent(() => import("../Campaign/index.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "LIST" }]],
  },
  {
    path: "campaign/create",
    component: asyncComponent(() => import("../Campaign/create.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "CREATE" }]],
  },
  {
    path: "campaign/edit/:id",
    component: asyncComponent(() => import("../Campaign/edit.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "EDIT" }]],
  },
  //
  // deprecated, backwards compatibility
  {
    path: "hotDeals",
    component: asyncComponent(() => import("../HotDeals/index.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "LIST" }],
    ],
  },
  {
    path: "hotDeals/create",
    component: asyncComponent(() => import("../HotDeals/create.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "CREATE" }],
    ],
  },
  {
    path: "hotDeals/edit/:id",
    component: asyncComponent(() => import("../HotDeals/edit.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "EDIT" }],
    ],
  },
  //
  {
    path: "coupon",
    component: asyncComponent(() => import("../Coupon/index.js")),
    requiredPermissionSets: [[{ section: "S_COUPON", function: "LIST" }]],
  },
  {
    path: "coupon/create",
    component: asyncComponent(() => import("../Coupon/create.js")),
    requiredPermissionSets: [[{ section: "S_COUPON", function: "CREATE" }]],
  },
  {
    path: "coupon/edit/:id",
    component: asyncComponent(() => import("../Coupon/edit.js")),
    requiredPermissionSets: [[{ section: "S_COUPON", function: "EDIT" }]],
  },
  {
    path: "coupon/view/:id",
    component: asyncComponent(() => import("../Coupon/edit.js")),
    requiredPermissionSets: [
      [{ section: "S_COUPON", function: "VIEW_DETAILS" }],
    ],
  },
  // deprecated, backwards compatibility
  {
    path: "promotion",
    component: asyncComponent(() => import("../Promotion/index.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "LIST" }]],
  },
  {
    path: "promotion/create",
    component: asyncComponent(() => import("../Promotion/create.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "CREATE" }]],
  },
  {
    path: "promotion/edit/:id",
    component: asyncComponent(() => import("../Promotion/edit.js")),
    requiredPermissionSets: [[{ section: "BANNER", function: "EDIT" }]],
  },
  //
  {
    path: "unpublishedPrivilege",
    component: asyncComponent(() => import("../UnpublishedPrivilege/index.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "LIST" }],
    ],
  },
  {
    path: "unpublishedPrivilege/create",
    component: asyncComponent(
      () => import("../UnpublishedPrivilege/create.js"),
    ),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "CREATE" }],
    ],
  },
  {
    path: "unpublishedPrivilege/edit/:id",
    component: asyncComponent(() => import("../UnpublishedPrivilege/edit.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "EDIT" }],
    ],
  },
  {
    path: "unpublishedPrivilege/view/:id",
    component: asyncComponent(() => import("../UnpublishedPrivilege/view.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "badge",
    component: asyncComponent(() => import("../Badge/index.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "LIST" }]],
  },
  {
    path: "badge/create",
    component: asyncComponent(() => import("../Badge/create.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "CREATE" }]],
  },
  {
    path: "badge/edit/:id",
    component: asyncComponent(() => import("../Badge/edit.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "EDIT" }]],
  },
  {
    path: "badge/editSp/:id",
    component: asyncComponent(() => import("../Badge/editSp.js")),
    requiredPermissionSets: [[{ section: "MISSION", function: "EDIT" }]],
  },
  {
    path: "badgeOfferPromotion",
    component: asyncComponent(() => import("../BadgeOfferPromotion/index.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "LIST" }],
    ],
  },
  {
    path: "badgeOfferPromotion/create",
    component: asyncComponent(() => import("../BadgeOfferPromotion/create.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "CREATE" }],
    ],
  },
  {
    path: "badgeOfferPromotion/edit/:id",
    component: asyncComponent(() => import("../BadgeOfferPromotion/edit.js")),
    requiredPermissionSets: [
      [{ section: "EXCLUSIVE_REWARD", function: "EDIT" }],
    ],
  },
  {
    path: "memberTags",
    component: asyncComponent(() => import("../MemberTags/index.js")),
    requiredPermissionSets: [[{ section: "MEMBER_TAG", function: "LIST" }]],
  },
  {
    path: "memberTags/create",
    component: asyncComponent(() => import("../MemberTags/create.js")),
    requiredPermissionSets: [[{ section: "MEMBER_TAG", function: "CREATE" }]],
  },
  {
    path: "memberTags/edit/:id",
    component: asyncComponent(() => import("../MemberTags/edit.js")),
    requiredPermissionSets: [[{ section: "MEMBER_TAG", function: "EDIT" }]],
  },
  {
    path: "memberTags/view/:id",
    component: asyncComponent(() => import("../MemberTags/view.js")),
    requiredPermissionSets: [
      [{ section: "MEMBER_TAG", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "spendingPointBonusRule",
    component: asyncComponent(
      () => import("../SpendingPointBonusRule/index.js"),
    ),
    requiredPermissionSets: [[{ section: "BONUS_RULE", function: "LIST" }]],
  },
  {
    path: "spendingPointBonusRule/create",
    component: asyncComponent(
      () => import("../SpendingPointBonusRule/create.js"),
    ),
    requiredPermissionSets: [[{ section: "BONUS_RULE", function: "CREATE" }]],
  },
  {
    path: "spendingPointBonusRule/edit/:id",
    component: asyncComponent(
      () => import("../SpendingPointBonusRule/edit.js"),
    ),
    requiredPermissionSets: [[{ section: "BONUS_RULE", function: "EDIT" }]],
  },
  {
    path: "spendingPointBonusRule/view/:id",
    component: asyncComponent(
      () => import("../SpendingPointBonusRule/edit.js"),
    ),
    requiredPermissionSets: [
      [{ section: "BONUS_RULE", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "user",
    component: asyncComponent(() => import("../UserManagement/index.js")),
    requiredPermissionSets: [[{ section: "USER", function: "LIST" }]],
  },
  {
    path: "user/create",
    component: asyncComponent(() => import("../UserManagement/create.js")),
    requiredPermissionSets: [[{ section: "USER", function: "CREATE" }]],
  },
  {
    path: "user/edit/:id",
    component: asyncComponent(() => import("../UserManagement/create.js")),
    requiredPermissionSets: [[{ section: "USER", function: "EDIT" }]],
  },
  {
    path: "userNotification",
    component: asyncComponent(() => import("../UserNotification/index.js")),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "LIST" }],
    ],
  },
  {
    path: "userNotification/create",
    component: asyncComponent(() => import("../UserNotification/create.js")),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "CREATE" }],
    ],
  },
  {
    path: "userNotification/edit/:id",
    component: asyncComponent(() => import("../UserNotification/edit.js")),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "EDIT" }],
    ],
  },
  {
    path: "userNotification/view/:id",
    component: asyncComponent(() => import("../UserNotification/edit.js")),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "merchantNotification",
    component: asyncComponent(() => import("../MerchantNotification/index.js")),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "LIST" }],
    ],
  },
  {
    path: "merchantNotification/create",
    component: asyncComponent(
      () => import("../MerchantNotification/create.js"),
    ),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "CREATE" }],
    ],
  },
  {
    path: "merchantNotification/edit/:id",
    component: asyncComponent(() => import("../MerchantNotification/edit.js")),
    requiredPermissionSets: [
      [{ section: "USER_PUSH_RECORD", function: "EDIT" }],
    ],
  },
  {
    path: "userInboxMessage",
    component: asyncComponent(() => import("../UserInboxMessage/index.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "LIST" }],
    ],
  },
  {
    path: "userInboxMessage/create",
    component: asyncComponent(() => import("../UserInboxMessage/create.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "CREATE" }],
    ],
  },
  {
    path: "userInboxMessage/edit/:id",
    component: asyncComponent(() => import("../UserInboxMessage/edit.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "EDIT" }],
    ],
  },
  {
    path: "userInboxMessage/view/:id",
    component: asyncComponent(() => import("../UserInboxMessage/edit.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "merchantInboxMessage",
    component: asyncComponent(() => import("../MerchantInboxMessage/index.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "LIST" }],
    ],
  },
  {
    path: "merchantInboxMessage/create",
    component: asyncComponent(
      () => import("../MerchantInboxMessage/create.js"),
    ),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "CREATE" }],
    ],
  },
  {
    path: "merchantInboxMessage/edit/:id",
    component: asyncComponent(() => import("../MerchantInboxMessage/edit.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "EDIT" }],
    ],
  },
  {
    path: "merchantInboxMessage/view/:id",
    component: asyncComponent(() => import("../MerchantInboxMessage/view.js")),
    requiredPermissionSets: [
      [{ section: "USER_INBOX_MESSAGE", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "changePassword",
    component: asyncComponent(() => import("../ChangePassword/index.js")),
    requiredPermissionSets: [
      [{ section: "SHOP", function: "CHANGE_PASSWORD" }],
    ],
  },
  {
    path: "checkInEvent",
    component: asyncComponent(() => import("../CheckInEvent/index.js")),
    requiredPermissionSets: [
      [{ section: "CHECK_IN_EVENT", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "checkInEvent/create",
    component: asyncComponent(() => import("../CheckInEvent/create.js")),
    requiredPermissionSets: [
      [{ section: "CHECK_IN_EVENT", function: "CREATE" }],
    ],
  },
  {
    path: "checkInEvent/edit/:id",
    component: asyncComponent(() => import("../CheckInEvent/edit.js")),
    requiredPermissionSets: [[{ section: "CHECK_IN_EVENT", function: "EDIT" }]],
  },
  {
    path: "checkInEvent/view/:id",
    component: asyncComponent(() => import("../CheckInEvent/edit.js")),
    requiredPermissionSets: [
      [{ section: "CHECK_IN_EVENT", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "merchantCustomReferralPoint",
    component: asyncComponent(
      () => import("../MerchantCustomReferralPoint/index.js"),
    ),
    requiredPermissionSets: [
      [{ section: "CUSTOM_REFERRAL_BONUS_POINT", function: "LIST" }],
    ],
  },
  {
    path: "merchantCustomReferralPoint/create",
    component: asyncComponent(
      () => import("../MerchantCustomReferralPoint/create.js"),
    ),
    requiredPermissionSets: [
      [{ section: "CUSTOM_REFERRAL_BONUS_POINT", function: "CREATE" }],
    ],
  },
  {
    path: "merchantCustomReferralPoint/edit/:id",
    component: asyncComponent(
      () => import("../MerchantCustomReferralPoint/edit.js"),
    ),
    requiredPermissionSets: [
      [{ section: "CUSTOM_REFERRAL_BONUS_POINT", function: "EDIT" }],
    ],
  },
  {
    path: "thirdPartyIntegrator",
    component: asyncComponent(() => import("../ThirdPartyIntegrator/index.js")),
    requiredPermissionSets: [
      [{ section: "THIRD_PARTY_INTEGRATOR", function: "LIST" }],
    ],
  },
  {
    path: "thirdPartyIntegrator/create",
    component: asyncComponent(
      () => import("../ThirdPartyIntegrator/create.js"),
    ),
    requiredPermissionSets: [
      [{ section: "THIRD_PARTY_INTEGRATOR", function: "CREATE" }],
    ],
  },
  {
    path: "thirdPartyIntegrator/edit/:id",
    component: asyncComponent(() => import("../ThirdPartyIntegrator/edit.js")),
    requiredPermissionSets: [
      [{ section: "THIRD_PARTY_INTEGRATOR", function: "EDIT" }],
    ],
  },
  {
    path: "thirdPartyIntegrator/view/:id",
    component: asyncComponent(() => import("../ThirdPartyIntegrator/edit.js")),
    requiredPermissionSets: [
      [{ section: "THIRD_PARTY_INTEGRATOR", function: "VIEW_DETAILS" }],
    ],
  },
  {
    path: "OCR_Test",
    component: asyncComponent(() => import("../OCRTest/index.js")),
    requireSuperPlusAdmin: true,
  },
  // Sino Club Member
  {
    path: "sinoClubMember",
    component: asyncComponent(() => import("../SinoClubMember/index.js")),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "LIST_MEMBER" }],
    ],
  },
  {
    path: "sinoClubMember/view/:id",
    component: asyncComponent(() => import("../SinoClubMember/view.js")),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "VIEW_MEMBER_DETAILS" }],
    ],
  },
  {
    path: "sinoClubMember/edit/:id",
    component: asyncComponent(() => import("../SinoClubMember/edit.js")),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "CREATE_MEMBER" }],
    ],
  },
  {
    path: "sinoClubMember/create",
    component: asyncComponent(() => import("../SinoClubMember/create.js")),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "CREATE_MEMBER" }],
    ],
  },
  {
    path: "sinoClubMember/import",
    component: asyncComponent(() => import("../SinoClubMember/import.js")),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "CREATE_MEMBER" }],
    ],
  },
  {
    path: "sinoClubMembershipUpgrade",
    component: asyncComponent(
      () => import("../SinoClubMembershipUpgrade/index.js"),
    ),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "LIST_MEMBERSHIP_UPGRADE" }],
    ],
  },
  {
    path: "sinoParking",
    component: asyncComponent(() => import("../SinoParking/index.js")),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "LIST_PARKING" }],
    ],
  },
  {
    path: "estate",
    component: asyncComponent(() => import("../Estate/index.js")),
    requiredPermissionSets: [[{ section: "ESTATE", function: "LIST" }]],
  },
  {
    path: "estate/edit/:id",
    component: asyncComponent(() => import("../Estate/edit.js")),
    requiredPermissionSets: [[{ section: "ESTATE", function: "EDIT" }]],
  },
  {
    path: "estate/view/:id",
    component: asyncComponent(() => import("../Estate/edit.js")),
    requiredPermissionSets: [[{ section: "ESTATE", function: "VIEW_DETAILS" }]],
  },
  {
    path: "estate/create",
    component: asyncComponent(() => import("../Estate/create.js")),
    requiredPermissionSets: [[{ section: "ESTATE", function: "CREATE" }]],
  },
  {
    path: "sinoClubPMemberReferralCode",
    component: asyncComponent(
      () => import("../SinoClubPMemberReferralCode/index.js"),
    ),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "LIST_PRIVILEGE_MEMBER_REFERRAL" }],
    ],
  },
  {
    path: "sinoClubPMemberReferralCode/create",
    component: asyncComponent(
      () => import("../SinoClubPMemberReferralCode/create.js"),
    ),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "CREATE_PRIVILEGE_MEMBER_REFERRAL" }],
    ],
  },
  {
    path: "sinoClubPMemberReferralCode/edit/:id",
    component: asyncComponent(
      () => import("../SinoClubPMemberReferralCode/edit.js"),
    ),
    requiredPermissionSets: [
      [{ section: "SINO_CLUB", function: "EDIT_PRIVILEGE_MEMBER_REFERRAL" }],
    ],
  },
  {
    path: "sinoClubPMemberReferralCode/view/:id",
    component: asyncComponent(
      () => import("../SinoClubPMemberReferralCode/edit.js"),
    ),
    requiredPermissionSets: [
      [
        {
          section: "SINO_CLUB_PRIVILEGE_MEMBER_REFERRAL",
          function: "VIEW_DETAILS",
        },
      ],
    ],
  },
  {
    path: "campaignCode",
    component: asyncComponent(() => import("../CampaignCode/index.js")),
    requiredPermissionSets: [[{ section: "CAMPAIGN_CODE", function: "LIST" }]],
  },
  {
    path: "campaignCode/create",
    component: asyncComponent(() => import("../CampaignCode/create.js")),
    requiredPermissionSets: [
      [{ section: "CAMPAIGN_CODE", function: "CREATE" }],
    ],
  },
  {
    path: "campaignCode/edit/:campaignId",
    component: asyncComponent(() => import("../CampaignCode/create.js")),
    requiredPermissionSets: [[{ section: "CAMPAIGN_CODE", function: "EDIT" }]],
  },
];

// class AppRouter extends Component {
//   render() {
//     const { style, authority } = this.props;
//     console.log('AppRouter authority', authority)
//     return (
//       <div style={style}>
//         <Switch>
//           <Route
//             path="/"
//             exact
//             component={asyncComponent(() => import("../Root/index.js"))}
//           />
//           <Route
//             exact
//             path="/changePassword"
//             component={asyncComponent(() => import("../ChangePassword/index.js"))}
//           />
//           {routes.map((singleRoute) => {
//             const { path, exact, allowAuthority, ...otherProps } = singleRoute;

//             if (allowAuthority.some((s) => authority.includes(s))) {
//               return (
//                 <Route
//                   exact={exact !== false}
//                   key={singleRoute.path}
//                   path={`/${singleRoute.path}`}
//                   {...otherProps}
//                 />
//               );
//             }
//             return null;
//           })}
//       </Switch>
//     </div>
//   );
// }
// };

const AppRouter = ({ style }) => {
  const { data } = usePermissions();
  return (
    <div style={style}>
      <Switch>
        <Route
          path="/"
          exact
          component={asyncComponent(() => import("../Root/index"))}
        />
          <Route
          exact
          path="/changePassword"
          component={asyncComponent(() => import("../ChangePassword/index.js"))}
        />
        {routes
          .filter(({ requiredPermissionSets, requireSuperPlusAdmin }) =>
            satisfyPermissionSets(
              data?.data,
              requiredPermissionSets,
              requireSuperPlusAdmin,
            ),
          )
          .map((singleRoute) => {
            const { path, exact, ...otherProps } = singleRoute;
            return (
              <Route
                exact={exact ?? true}
                key={path}
                path={`/${path}`}
                {...otherProps}
              />
            );
          })}
      </Switch>
    </div>
  );
};

export default withRouter(AppRouter);
